class ArrayClass {
  /**
   * Separar los arreglos de un arreglo por el parámetro separator
   * @param {Array} array
   * @param {String} separator
   * @returns
   */
  static joinSeparateByParam(array, separator = ',') {
    return array
      .map((element) =>
        Number.isFinite(element) ? element.toString() : `'${element}'`
      )
      .join(`${separator} `);
  }

  /**
   * Obtener el valor que mas se repite del array por parámetro
   * @param {Array} data
   * @returns
   */
  static getMostRepeatedValue(data) {
    if (data.length === 0) return null;
    const counts = data.reduce((acc, curr) => {
      if (curr !== null) {
        acc[curr] = (acc[curr] || 0) + 1;
      }
      return acc;
    }, {});

    if (Object.keys(counts).length === 0) return null;

    return Object.keys(counts).reduce((a, b) =>
      counts[a] > counts[b] ? a : b
    );
  }
}

export default ArrayClass;
